import LocalStorageService from "@application/features/Common/local-storage-service";
import axios from "axios";
import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const baseURL = process.env.REACT_APP_API_BASE_URL;
const login = () => {
    const msAccesstoken = LocalStorageService.getMSAccessToken(); // Retrieve the token from localStorage
    const accessToken = LocalStorageService.getAccessToken();
    if (!msAccesstoken) {
        throw new Error("Token not found in localStorage");
    }
    return axios.get(`${baseURL}account/token`, {
        headers: {
            Authorization: `Bearer ${msAccesstoken}`,
            XAuthorization: `Bearer ${accessToken}` // Attach the token with the "Bearer " prefix
        },
    });
};
const getRefreshToken = (refreshToken) => {
    return vdkHappinessPortalApi.post("auth/refresh", refreshToken);
};
const verifyToken = (refreshToken) => {
    return vdkHappinessPortalApi.post("token/verify-token", refreshToken);
};
const AuthApi = {
    login,
    getRefreshToken,
    verifyToken,
};
export default AuthApi;
